import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const EVENT_TICKET_TYPES_EVENT_TICKET_TYPE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/event-ticket-types',
        iconClass: 'fas fa-ticket',
        name: '::Menu:EventTicketTypes',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.EventTicketTypes',
      },
    ]);
  };
}
